import { render, staticRenderFns } from "./page.vue?vue&type=template&id=7e4e2521&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4e2521",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4e2521')) {
      api.createRecord('7e4e2521', component.options)
    } else {
      api.reload('7e4e2521', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=7e4e2521&scoped=true&", function () {
      api.rerender('7e4e2521', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/secure/entries/co-pilot/routes/project-submission/page.vue"
export default component.exports